// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__19pm_","amount":"Amount_amount__1I7-j","tip":"Amount_tip__rIMo2","tipHeader":"Amount_tipHeader__2f3B4","tipsWrap":"Amount_tipsWrap__2djD9"};